<template>
  <div class="home" style="background-color:white">

 <div  class="displayMain">
    <div class="displayMainHolder">
      <div class="mainPop container">
       
      <br />
        <div class="pop">
          The Platform for Live Streaming Sports
        </div>
        <br />
        <div class="pop-info">
          Create professional-grade live streams for your team without needing complex software or expensive equipment. Start broadcasting today with a device you already own:
 
          <br />
          <br />
      
           
      
          <div   class="row">
            <div class="col-12">
               <router-link to="/StartBroadcasting"
                class="btn btn-block btn-primary w-100">Start Broadcasting</router-link>
                   <router-link to="/search"
                class="btn btn-block btn-light w-100">Watch My Team</router-link><br />
                          <a  href='https://apps.apple.com/us/app/gametime-broadcast/id1392642543?mt=8"'><img alt='Download on App Store' height="40" src='../assets/badge-lrg.svg'/></a>
    
                   <a  href='https://play.google.com/store/apps/details?id=com.mclmediagroup.seasoncast&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' height="58" src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>

            </div>
           
          </div>



        </div>
      </div>

      </div>
    </div>
      <div style="background-color:#ebebeb; z-index: 1000000" class="display2">
    <div  style="width:100%; text-align: center; padding:5px">
      SeasonCast is proudly the broadcasting platform of choice for <b>5,000+</b> teams.
        </div>
      </div>
    <div class="p-3 w-100">
      <div v-if="apiToken">
      <!-- Popular Events Listed -->
      <br />
         <h5>Your Followed Channels</h5>
      <hr />
   <div v-if="followedChannels" class="row ">

  <div class="col-6  col-md-4 col-lg-2 p-2" v-for="(channel, index) in followedChannels" v-bind:key="index" v-bind:onclick="'window.location = \'/'+channel.id+'\''" >
      <div style="cursor:pointer; padding:0; text-align:center" class="seasoncast-card">
      <div v-bind:style="'background-color:#'+((channel && channel.pageData) ? JSON.parse(channel.pageData).navcolor : '000000')" style="width:100%; border-top-left-radius: 0.3em; border-top-right-radius: 0.3em; color:white; padding: 0.4em; font-weight:bold">
       <span style=" display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;"> {{channel.name}}</span>
      </div>
  <div class="p-3"  >
    <div style="position: relative;">
         <!-- <img style="width: 100%; height: auto; "
                v-bind:src="'https://dvr.bunny.seasoncast.com/file/mylivegame/recordings/'+channel.id+'/'+channel.recent+'/thumbnail.jpg'"
                onerror="this.onerror=null;this.src='https://app.seasoncast.com/img/live_event.png';" /> -->
                            <button  v-bind:onclick="'window.location = \'/'+channel.id+'\''" type="button"  class="btn btn-dark btn-block">Go to Channel</button>

                <div  v-if="channel.isLive == 1" style="   position: absolute; bottom: 2px;  left: 2px; padding-right:5px; padding-left:5px; font-weight:bold; color:white; text-align:left; background-color:black; opacity:0.8;"><span class="dot"></span> Live</div>
    </div>
  </div>
     <span hidden style=" display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis; padding:5px"></span>
     </div>
</div>
</div>
  <div v-if="followedChannels.length == 0">  <span v-if="!apiToken"> Please login to view followed channels <a  href="/viewer/login">[Login to Viewer Account]</a></span><span v-else>No followed channels</span></div>
      <br />
      <br />

       <br />
      
      </div>
       <br />
      <h5>Today's Top Ranked Channels in your Area</h5>
      <hr />
<div class="row ">

  <div class="col-6  col-md-4 col-lg-2 p-2" v-for="(event, index) in popularNow[0].list" v-bind:key="index" v-bind:onclick="'window.location = \'/'+event.channel.id+'\''" >
      <div style="cursor:pointer; padding:0; text-align:center" class="seasoncast-card">
      <div v-bind:style="'background-color:#'+((event.channel && event.channel.pageData) ?  event.channel.pageData.navcolor : '000000')" style="width:100%; border-top-left-radius: 0.3em; border-top-right-radius: 0.3em; color:white; padding: 0.4em; font-weight:bold">
       <span style=" display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;"> {{event.channel.name}}</span>
      </div>
  <div class="p-3" >
         <img style="width: 100%; height: auto; border-radius: 5px;"
                v-bind:src="'https://dvr.bunny.seasoncast.com/file/mylivegame/recordings/'+event.channel.id+'/'+event.session+'/thumbnail.jpg'"
                onerror="this.onerror=null;this.src='https://app.seasoncast.com/img/live_event.png';" />
  </div>
     <span hidden style=" display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis; padding:5px"></span>
     </div>
</div>
</div>
<br />

<div class="text-center w-100">
        <router-link to="/search"
                class="btn btn-lg btn-secondary ">Find My Team's Channel</router-link>
                </div>
    </div>
<br />
<br />
<br />

  <div class="display3">
    <div class="container">
      <div class="pop-white ">
        Ready to Get Started?
      </div>
      <br />
      <router-link to="/StartBroadcasting"
        class="btn-block btn-lg btn-light">Get Started Broadcasting Guide</router-link>
      <br />
    </div>


  </div>

  </div>
 

</template>

<script>

import axios from "axios"
   import cookie from "cookie.js"

let API = "https://app.seasoncast.com/"

export default {
  name: 'Home',
  components: {
 
  },
    data: function () {
    return {
      popularNow: [],
      followedChannels: undefined,
      apiToken: undefined
    }
  },
  created: async function () {
    document.title =  "SeasonCast"
    this.apiToken = cookie.get("viewer-token")
    this.popularNowCall()

    if (this.apiToken){
    this.followedChannelsCall()
    }else{
      this.followedChannels = []
    }
  },
    methods: {
 formatToPrice(value) {
      return `${value.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    },
    popularNowCall: async function () {
      //could add more parametes later
    let getEventResponse = await axios.post(API+ "v2/global/popular", {

  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
    console.log("error loading popular now")
  }
console.log(responseData.result)
  this.popularNow = responseData.result
    


    },
      followedChannelsCall: async function () {
      //could add more parametes later
    let getEventResponse = await axios.post(API+ "v2/viewer/followed", {
     email: cookie.get("viewer-email"),
    token:  cookie.get("viewer-token"),
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
    console.log("error loading followed now")
  }
console.log(responseData.channels)
  this.followedChannels = responseData.channels
    


    },
}
}
</script>
<style lang="scss" scoped >

@media only screen and (min-width: 968px) {
  .centerText{
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    width:90%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .pop {
    font-weight: bold;
    font-size: 4rem;
    line-height: 1.1em;
    font-size:8vh;
     text-transform: uppercase;

  }

}
.mainPop{
  max-width: 500px;
}
@media only screen and (max-width: 768px) {
  .centerText{
    padding-bottom:3vh;
    padding-top:3vh;
  }
.mainPop{
  width:99%
}
.pop {
  font-weight: bold;
  font-size: 2rem;
  line-height: 1em;
   text-transform: uppercase;
}
}

.img-50{
  width: 50%;
   object-fit: contain;
}
.img-20{
  width: 30%;
   object-fit: contain;
}
.pop{
  font-size: 2rem; 
  font-weight: bold;
  text-transform: uppercase;
}
.dot {
  height: 10px;
  width: 10px;
  background-color: rgb(247, 7, 7);
  border-radius: 50%;
  display: inline-block;
}
.pop-white {
 
  font-size: 2rem;
  font-size: 3vh;
  text-align:center;
  width:100%;
  padding:2rem;
  padding:1vh;
}
.pop-info{
  font-size: 1rem;
  font-weight: 500;
  
}
.scLink {
  color:#353f56;
  font-size: 0.9em;

}
.scLink :hover {
  color:#4363af ;


}
.displayMainHolder{

 position: relative;
width:100%;
height:100%;
}
.user{
  border-radius: 1px;
  background: #e2e2e2;
  background: inherit;
  color:inherit;
  color:#6d6d6d;
  padding: 1vh;
  width: 70%;
  font-size: 1.2vh;
  margin: 0 auto;

}
.displayMain{
  background:linear-gradient(0deg,rgba(47, 44, 83, 0.86),rgba(47, 44, 83, 0.86)),url(../assets/baseballkid2.jpg);

   background-color: black; /* Used if the image is unavailable */
   background-position: center top; /* Center the image */
   background-repeat: no-repeat; /* Do not repeat the image */
   background-size: cover;


  

color:white;
text-align:center;
padding:1.0em;

width:100%;
}

.display2{


color:#333333;
text-align:center;

padding-top:4vh;
padding-bottom:4vh;
}
.display3{

background-color: #2d2d54;
color:white;
text-align:center;

padding-top:4vh;
padding-bottom:4vh;
}
</style>
